<template>
  <div>
    <div
      id="content"
      v-viewport
    >
      <default-top :screen="isLogoVisible" />
      <page-header :text="headerText" />
      <div class="container">
        <div class="row pt-4 pb-4">
          <div class="column col-lg-4 offset-lg-4 text-center">
            <img
              class="illustration"
              :src="getFile(regulation.path)"
              :alt="regulation.name"
            >
          </div>
        </div>
        <div class="row">
          <div class="column col-lg-6 offset-lg-3">
            <div class="block block-default text-center mb-4">
              <span class="regulation-title regulation--type">
                {{ regulation.type }}
              </span>
              <h1 class="regulation-title regulation--title">
                {{ regulation.title }}
              </h1>
              <h2 class="regulation-title regulation--sub-title">
                {{ regulation.sub_title }}
              </h2>
              <span
                class="hr mt-4 mb-4"
                :class="getRouteClass"
              />
            </div>
            <transition
              name="fade"
              mode="out-in"
            >
              <div v-show="isRoute">
                <div class="block block-default block-alt mb-0">
                  <div class="content text-center">
                    {{ regulation.details }}
                  </div>
                  <div
                    v-dompurify-html="regulation.advantage"
                    class="content"
                  />
                </div>
                <span class="arrow mt-4 mb-4" />
              </div>
            </transition>
          </div>
        </div>
      </div>
      <router-view v-slot="{ Component }">
        <transition
          name="fade"
          mode="out-in"
        >
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import store from 'domain/store/index'
import { mapState } from 'vuex'

import PageHeader from 'app/components/shared/page-header'

import image from 'app/mixin/image'

import httpHelper from 'app/helpers/http'
import imageHelper from 'app/helpers/image'
import tenantHelper from 'app/helpers/tenant'

export default {
  name: 'Regulation',
  components: {
    PageHeader
  },
  mixins: [image],
  beforeRouteEnter (to, from, next) {
    store.dispatch('getRegulation', to.params.id).then(function (response) {
      imageHelper.loadImage(response.path).then(function () {
        next()
      })
    }).catch(response => {
      if (httpHelper.isHttpError(response)) {
        next({ name: '404' })
      }
    })
  },
  data () {
    return {
      headerText: tenantHelper.get('payoff'),
      isLogoVisible: 'md'
    }
  },
  computed: {
    ...mapState([
      'loading',
      'regulation'
    ]),
    isRoute () {
      return this.$route.name !== 'contact'
    },
    getRouteClass () {
      return this.$route.name !== 'contact' ? 'visible' : 'invisible'
    }
  }
}
</script>
